import { render, staticRenderFns } from "./PostAboutStep.vue?vue&type=template&id=7d2f13a6&scoped=true&"
import script from "./PostAboutStep.vue?vue&type=script&lang=js&"
export * from "./PostAboutStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2f13a6",
  null
  
)

export default component.exports